// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/fastex/reportsystem/webadmin/src/models/global.model';
import model_2 from '/home/fastex/reportsystem/webadmin/src/models/notification.model';
import model_3 from '/home/fastex/reportsystem/webadmin/src/models/user.model';

export const models = {
model_1: { namespace: 'global', model: model_1 },
model_2: { namespace: 'notification', model: model_2 },
model_3: { namespace: 'user', model: model_3 },
} as const
